<div class="flex-column gap-S">
	<div class="flex-align-center flex-space-between">
		<div class="flex-align-center gap-S">
			<div class="font-MM fw-700">{{ 'page.infrastructure.network.servers' | translate }}</div>
			<img *ngIf="tooMuchServers" src="assets/icons/warning-triangle.svg" [tooltip]="'page.infrastructure.network.tooMuchServers2' | translate" tooltipPosition="bottom" [tooltipOffset]="5">
		</div>
	</div>
	@for (server of servers; track server.server.id) {
		<div class="server-card">
			<div (click)="goToServer(server.server.id)"
				 class="pl-s pr-m pt-s pb-s flex-space-between flex-align-center gap-S c-p greyed-hover-2">
				<div class="flex-align-center c-p" style="gap: 60px">
					<div style="user-select: none" class="flex-center gap-S">
						<app-server-icon [size]="38" [server]="server.server"></app-server-icon>
						<div class="flex-justify-center flex-column gap-XS" style="width: 130px">
							<div class="text-overflow-ellipsis font-M fw-700">
								{{ server.server.name }}
							</div>
							<div *ngIf="server.server.type" class="text-overflow-ellipsis font-S">
								{{ 'page.infrastructure.overview.types.' + server.server.type | translate }}
							</div>
							<div *ngIf="!server.server.type" class="text-overflow-ellipsis font-S">
								-
							</div>
						</div>
						<app-chips-criticality short [criticality]="server.criticality"></app-chips-criticality>
					</div>
					<div class="flex-align-center gap-XS">
						<app-chips-text [warning]="getServerPrimaryIpAddress(server.server) ? !isIpInRange(getServerPrimaryIpAddress(server.server)!, network.ipAddress, network.subnet) ? ('page.infrastructure.network.serverNotInRange' | translate) : undefined : undefined">
							<span class="pad-0-XS font-M">{{ getServerPrimaryIpAddress(server.server) || '-' }}</span>
						</app-chips-text>
						<div class="interface-counter flex-center pad-0-S" *ngIf="server.server.interfaces.length > 1" [tooltipTriggerFor]="tooltip" style="cursor:default;">
							<span class="font-S fw-500">+{{ server.server.interfaces.length - 1 }}</span>
						</div>
						<app-tooltip #tooltip>
							<div *ngFor="let serverInterface of server.server.interfaces" class="flex-align-center gap-XS">
								<span>{{ serverInterface.serverInterface.ipAddress }}</span>
							</div>
						</app-tooltip>
					</div>

				</div>
				<div class="flex-align-center gap-XL">
					<div class="flex-space-between pad-right-S" style="padding-left: 35px"
						 *ngIf="server.server.automatic && server.server.dataCollectionStatus">
						<div *ngIf="server.server.dataCollectionStatus === DataCollectionStatus.ACTIVE"
							 class="signal signal-success"
							 [tooltip]="getDataCollectionStatusTooltip(server.server.dataCollectionStatus!!, server.server.lastCheckTime)"
							 tooltipPosition="right">
							<img src="assets/icons/signal.svg" class="filter-success" height="20">
						</div>
						<div *ngIf="server.server.dataCollectionStatus === DataCollectionStatus.OUTDATED"
							 class="signal signal-warning"
							 [tooltip]="getDataCollectionStatusTooltip(server.server.dataCollectionStatus!!, server.server.lastCheckTime)"
							 tooltipPosition="right">
							<img src="assets/icons/signal.svg" class="filter-warning" height="20">
						</div>
						<div *ngIf="server.server.dataCollectionStatus === DataCollectionStatus.ERROR"
							 class="signal signal-danger"
							 [tooltip]="getDataCollectionStatusTooltip(server.server.dataCollectionStatus!!, server.server.lastCheckTime)"
							 tooltipPosition="right">
							<img src="assets/icons/signal.svg" class="filter-danger" height="20">
						</div>
					</div>
					<div class="flex-space-between pad-right-S" style="padding-left: 35px"
						 *ngIf="!server.server.dataCollectionStatus">
						<div class="signal signal-secondary">
							<img src="assets/icons/signal.svg" class="filter-grey" height="20">
						</div>
					</div>
					<div style="margin-left: auto">
						<div class="disp-f justify-center a-i-c">
							<img src="assets/icons/arrow-right.svg">
						</div>
					</div>
				</div>
			</div>
		</div>
	} @empty {
		<div class="w-100 flex-center flex-column" style="gap: 30px; height: 280px;">
			<img src="../../../../../../../../assets/illustrations/empty-app.svg" width="150">
			<span class="grey">{{ 'page.infrastructure.network.noServerAttached' | translate }}</span>
		</div>
	}
</div>
